import {Component, Input, OnInit} from '@angular/core';
import {SkeletonComponent} from "../../skeleton/skeleton.component";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-skeleton-universal',
  templateUrl: './skeleton-universal.component.html',
  standalone: true,
  imports: [
    SkeletonComponent,
    NgForOf
  ],
  styleUrls: ['./skeleton-universal.component.scss']
})
export class SkeletonUniversalComponent implements OnInit {
  @Input()count = 1
  @Input()cwidth:any;
  @Input()cheight:any
  @Input()rwidth:any
  @Input()rheight:any
  @Input()circle:any
  constructor() { }

  ngOnInit(): void {
  }


}
